import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const getNotifications = createAsyncThunk("notification/getNotifications", async () => {
  try {
    const response = await axios.get(`/GetNotifications`);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const updateNotificationStatus = createAsyncThunk("notification/updateNotificationStatus", async (data) => {
  try {
    const response = await axios.post(`/UpdateNotificationStatus`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});